// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2851":"5c3327777d8a39a6","7005":"071e71780554fd39","9248":"5c5974ea0c6e7b7d"}[chunkId] + ".css";
};